<template>
  <div>
    <el-button type="text"
               @click="outerVisible = true">点击打开外层 Dialog</el-button>

    <el-dialog title="外层 Dialog"
               :visible.sync="outerVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               append-to-body
               :show-close="false">
      <el-dialog width="30%"
                 title="内层 Dialog"
                 :visible.sync="innerVisible"
                 append-to-body>
      </el-dialog>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="innerVisible = true">打开内层 Dialog</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      outerVisible: false,
      innerVisible: false
    };
  }
}
</script>


// WEBPACK FOOTER //
// src/view/main/test.vue